/**
 * Shopify low-level client + shared constants.
 * All Storefront API requests go through `shopifyRequest`, which proxies via
 * the `shopify-products` Edge Function (so the Storefront token stays server-side).
 */

export const EDGE_FUNCTION_URL =
  "https://injtcwsaozsjysyjwyot.supabase.co/functions/v1/shopify-products";

/** Permanent Shopify domain used for checkout fallback (do not change). */
export const PERMANENT_SHOPIFY_DOMAIN = "alice-jewelry-il.myshopify.com";

/** Hidden addon products that should never appear in product listings, search, or grids. */
export const HIDDEN_PRODUCT_HANDLES = new Set<string>([
  "תוספת-אייקון-לחריטה",
]);

/** Filter out hidden addon products from display. */
export function filterHiddenProducts<
  T extends { handle?: string; node?: { handle?: string } }
>(items: T[]): T[] {
  return items.filter((item) => {
    const handle = item.handle || item.node?.handle;
    return !handle || !HIDDEN_PRODUCT_HANDLES.has(handle);
  });
}

export async function shopifyRequest(query: string, variables: any = {}) {
  try {
    const response = await fetch(EDGE_FUNCTION_URL, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ query, variables }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const result = await response.json();

    if (result.errors) {
      throw new Error(
        `GraphQL error: ${result.errors.map((e: any) => e.message).join(", ")}`
      );
    }

    return result;
  } catch (error) {
    console.error("Error in Shopify request:", error);
    throw error;
  }
}
